module.exports = __webpack_public_path__ + "img/confirm.3e1fc8f2.svg";